export default "__VITE_ASSET__DonGGr3a__"